// BlobComponent.js
import React from 'react';
import PropTypes from 'prop-types';

const BlobComponent = ({ color, position, animation }) => {
  const blobColor = color || '#d4d4d4';
  const blobStyle = {
    // Soft edge via radial-gradient instead of filter: blur(150px), which is very
    // expensive to paint on iOS Safari and stalls first render
    background: `radial-gradient(circle closest-side, ${blobColor} 0%, ${blobColor}99 45%, ${blobColor}00 100%)`,
    position: 'absolute',
    ...position,
    animation,
  };
  return <div className={`blob ${blobColor.toLowerCase()}`} style={blobStyle}></div>;
};

BlobComponent.propTypes = {
  color: PropTypes.string,
  position: PropTypes.object.isRequired,
  animation: PropTypes.string,
};

export default BlobComponent;
